// extracted by mini-css-extract-plugin
export default {"description":"CopilotAssignmentModal-module__description--aNFpM","errorContainer":"CopilotAssignmentModal-module__errorContainer--r6dlx"};